import classNames from 'classnames'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import gaugeType from '@/components/Stocks/Utils/gauageUtils'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/revamp/reusable-components/tooltip/tooltip'
import Info from '@/assets/common/info.inline.svg'

const tableHeads = ['Name', 'Value', 'Action']

const Table = props => {
  if (!props.indicators.length) return null
  return (
    <div className="relative flex justify-center overflow-x-auto">
      <table
        className={classNames(
          'relative w-full table-auto',
          props.className ?? '',
        )}
        cellPadding={10}
      >
        <thead>
          <tr>
            {tableHeads.map((el, index) => {
              const isFirst = index === 0

              return (
                <th
                  key={`${el}-${index}`}
                  className={classNames(
                    'text-13px text-brand-grey-base py-2 font-medium',
                    {
                      'text-right': !isFirst,
                      'text-brand-grey-dark w-72 text-left': isFirst,
                    },
                  )}
                >
                  <p>{el}</p>
                </th>
              )
            })}
          </tr>
        </thead>

        <tbody>
          {props.indicators.map(({ name, value, trend }, index) => {
            return (
              <tr key={index} className="border-b-1">
                {[name, value, trend].map((cell, index) => {
                  const isFirst = index === 0
                  const { typeTxt, color } = gaugeType({
                    type: cell,
                  })
                  const cellTxt = typeTxt ? typeTxt : cell

                  return (
                    <td
                      key={`${cell}-${index}`}
                      className={classNames('py-3 lg:text-base', {
                        'flex items-center': cell.text && cell.icon,
                        'text-left': isFirst,
                        'text-right': index !== 0,
                      })}
                    >
                      {cell.icon && (
                        <div className="flex-shrink-0">
                          <StencilCDNImage
                            alt={cell.text}
                            src={cell.icon}
                            width={34}
                            height={34}
                            className="rounded-full"
                          />
                        </div>
                      )}

                      <div
                        className={classNames('text-sm', {
                          'flex items-center': isFirst,
                        })}
                      >
                        <div className={color}>{cellTxt}</div>
                        {cell.tooltip && (
                          <div className="ml-1 flex items-center">
                            <Tooltip>
                              <TooltipTrigger>
                                <Info className="h-4 w-4" />
                              </TooltipTrigger>

                              <TooltipContent>
                                <div
                                  className="bg-brand-white text-11px shadow-two min-w-[200px] max-w-xs rounded-xl p-4"
                                  dangerouslySetInnerHTML={{
                                    __html: cell.tooltip,
                                  }}
                                />
                              </TooltipContent>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
